<template>
	<div class="flex flex-col h-full">
		<div class="textarea-wrapper">
			<textarea
				:ref="referAttr"
				required
				:value="value"
				:placeholder="textareaPlaceholder"
				class="resize-none px-1 mb-4 font-roboto w-full full-length-textarea border rounded focus:outline-none focus:ring-0"
				:maxlength="maxCharLength"
				@input="handleInput"
				@focus="isFocused = true"
				@blur="isFocused = false"
			></textarea>

			<div v-if="isFocused" class="char-counter">
				<span>{{ charCount }}/{{ maxCharLength }}</span>
			</div>
		</div>
		<div v-if="internalErrorMessage" class="text-red-500 text-base mb-2">
			{{ internalErrorMessage }}
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		charCount() {
			return Math.max(this.value.length, 0)
		},
	},
	methods: {
		handleInput(event) {
			this.$emit('input', event.target.value)
			// Validate on type if both props are true
			if (this.isRequired && this.validateOnType) {
				this.validate()
			}
		},
		validate() {
			this.internalErrorMessage = ''
			if (this.isRequired && !this.value.trim()) {
				this.internalErrorMessage = 'Reply is required'
				return false
			}
			return true
		},
	},
	name: 'NoteTextArea',
	props: {
		value: { type: String, default: '' },
		maxCharLength: { type: Number, default: 500 },
		textareaPlaceholder: {
			type: String,
			default: 'Enter new note here...',
		},
		referAttr: { type: String, default: null },
		isRequired: {
			type: Boolean,
			default: false,
		},
		validateOnType: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		value() {
			// Validate when value changes if both props are true
			if (this.isRequired && this.validateOnType) {
				this.validate()
			}
		},
	},
	data() {
		return {
			internalErrorMessage: '',
			isFocused: false,
		}
	},
}
</script>
